import React, {Component} from 'react';
import {connect} from "react-redux";
import UnitListItem from "./UnitListItem";
import './styles.css';
import {getUnit} from "../../unit/utils";

/**
 * A list of Units to be displayed on the dashboard
 */
class UnitList extends Component {
    render() {
        return (this.props.units && Object.keys(this.props.units).length > 0) ? (
            <div style={{maxHeight: '320px', overflow: 'auto'}}>
                {
                    Object.keys(this.props.units).map(unitKey =>
                        <UnitListItem
                            key={unitKey}
                            unit={getUnit(unitKey, this.props.units[unitKey])}
                        />
                    )
                }
            </div>
        ) : null;
    }
}

/**
 * Map Redux {@param state} to component props
 */
const mapStateToProps = (state) => ({
    units: state.unitsState.units
});

export default connect(mapStateToProps)(UnitList);



// WEBPACK FOOTER //
// ./src/components/dashboard/unitlist/UnitList.jsx